import {NgModule} from '@angular/core';
import {UserProfileComponent} from './user-profile/user-profile.component';
import {SharedModule} from '@helpers/modules/shared.module';
import {LayoutModule} from '../../layout-components/layout.module';
import { UserFormService } from './services/user-form.service';
import { UserFormResolverService } from './services/user-form-resolver.service';
import {ActivationRequestComponent} from './activation-request/activation-request.component';
import {NotificationsComponent} from './notifications/notifications.component';
import {PagingControlModule} from '@components/paging-control/paging-control.module';
import {IconsModule} from '@lab365/icons';


@NgModule({
    imports: [
        SharedModule,
        LayoutModule,
        PagingControlModule,
        IconsModule,
    ],
    exports: [],
    declarations: [
        UserProfileComponent,
        NotificationsComponent,
        ActivationRequestComponent,
    ],
    providers: [
        UserFormService,
        UserFormResolverService,
    ],
})
export class ProfileModule {
}
